import React, { useState } from "react";

interface TabProps {
    labels: string[];
    children: React.ReactNode[];
}

const Tabs: React.FC<TabProps> = ({ labels, children }) => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <div>
            <ul className="tab-labels">
                {labels.map((label, index) => (
                    <li
                        key={index}
                        className={activeTab === index ? "active" : ""}
                        onClick={() => setActiveTab(index)}
                    >
                        {label}
                    </li>
                ))}
            </ul>
            <div className="tab-content">
                {children[activeTab]}
            </div>
        </div>
    );
};

export default Tabs;